import ImageWithBasePath from "../../../core/common/imageWithBasePath";

const AccessDenied = () => {
  return (
    <div>
      <div className="row justify-content-center">
        <div className="col-xxl-6 col-xl-7 col-md-6">
          <div className="d-flex flex-column justify-content-between vh-100">
            <div className="text-center p-4">
              <ImageWithBasePath
                src="assets/img/logo.svg"
                alt="img"
                className="img-fluid"
              />
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center mb-4">
              <div className="mb-4">
                <ImageWithBasePath
                  src="assets/img/authentication/error-401.svg"
                  className="error-img img-fluid"
                  alt="Img"
                  height={500}
                  width={500}
                />
              </div>
              <h3 className="h2 mb-3">Access Denied</h3>
              <p className="text-center">
                You do not have permission to access this page.
              </p>
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center"
                onClick={() => window.history.back()}
              >
                <i className="ti ti-arrow-left me-2" />
                Back
              </button>
            </div>
            {/* <div className="text-center p-4">
              <p>Copyright © 2024 - Preskool</p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default AccessDenied;
